/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';

import { getTopListsMap } from 'components/TopUsers/_common/topListsMap';

const rightSidebarViewTaskAsOwner = () => {
  const [topListsMap] = useState(getTopListsMap());
  return (
    <React.Fragment>
      <div className="page-sidebar-sticky">
        <div className="page-sidebar-sticky-wrp">
          <div
            aria-multiselectable="true"
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
          >
            {Object.keys(getTopListsMap()).map(key => {
              const item = topListsMap[key];
              return (
                <NavLink
                  key={`topListsMap${key}`}
                  to={`/users/top-users/${key}`}
                  activeClassName="active"
                  className="list-group-item"
                >
                  <span className="list-group-item-val text-overflow">
                    <i
                      className={`${item.iconClass} fa-fw`}
                      aria-hidden="true"
                    />{' '}
                    {item.name}
                  </span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

rightSidebarViewTaskAsOwner.contextTypes = {
  router: PropTypes.shape()
};

rightSidebarViewTaskAsOwner.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(rightSidebarViewTaskAsOwner);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/TopUsers/RightSidebarTopUsers/RightSidebarTopUsers.js